import { ButtonHTMLAttributes, FC, PropsWithChildren, ReactNode, forwardRef } from 'react';

import { overlayBoxStyle, overlayButtonStyle } from './ButtonOverlay.css';
import { getClassNames } from '../../util/css';

type ButtonProps = Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  className?: never;
  children: ReactNode;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ children, className = '', ...props }, ref) => {
  const classNames = getClassNames(overlayButtonStyle, className);
  return (
    <button ref={ref} {...props} className={classNames}>
      {children}
    </button>
  );
});

interface CompoundButtonOverlay {
  Button: typeof Button;
}

export const ButtonOverlay: FC<PropsWithChildren<{ className?: never }>> & CompoundButtonOverlay = ({
  className,
  children,
}) => <div className={getClassNames(overlayBoxStyle, className)}>{children}</div>;

ButtonOverlay.Button = Button;
ButtonOverlay.Button.displayName = 'ButtonOverlay.Button';
